import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';

import ENGLISH from './english.json';
import IRISH from './irish.json';

Vue.use(VueI18n);

const messages = {
  ENGLISH,
  IRISH,
};

const i18n = new VueI18n({
  locale: store.state.currentLanguage.toUpperCase(),
  messages,
});

export default i18n;
